import React from "react";
import { useTranslation } from "react-i18next";
import { ArrowRight, Eye, Layers3, MapPinned, Target } from "lucide-react";
import about from "../../img/about.jpg";

const highlights = [
  {
    icon: Layers3,
    titleKey: "company.highlights.platform.title",
    descriptionKey: "company.highlights.platform.description",
  },
  {
    icon: Eye,
    titleKey: "company.highlights.visibility.title",
    descriptionKey: "company.highlights.visibility.description",
  },
  {
    icon: MapPinned,
    titleKey: "company.highlights.valencia.title",
    descriptionKey: "company.highlights.valencia.description",
  },
];

export const Mission = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-8 md:space-y-10">
      <section className="grid gap-6 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)]">
        <div className="rounded-[1.75rem] border border-slate-200 bg-gradient-to-br from-white to-slate-50 p-6 shadow-lg md:p-8">
          <div className="inline-flex items-center gap-2 rounded-full border border-blue-200 bg-blue-50 px-4 py-2 text-sm font-semibold text-blue-700">
            <Target className="h-4 w-4" />
            {t("company.missionBadge")}
          </div>

          <h2 className="mt-5 text-2xl font-bold tracking-tight text-slate-900 md:text-3xl">
            {t("company.introTitle")}
          </h2>

          <p className="mt-4 text-base leading-7 text-slate-700 md:text-lg">
            {t("company.introBody")}
          </p>

          <div className="mt-6 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
            <p className="text-sm font-semibold uppercase tracking-[0.25em] text-slate-500">
              {t("company.mottoLabel")}
            </p>
            <p className="mt-2 text-lg font-semibold text-slate-900">
              {t("company.motto")}
            </p>
          </div>
        </div>

        <div className="relative overflow-hidden rounded-[1.75rem] border border-white/10 bg-white/5 shadow-2xl shadow-black/20 backdrop-blur-xl">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 via-transparent to-purple-500/10" />
          <img
            src={about}
            className="relative h-full min-h-[320px] w-full object-cover"
            alt={t("company.imageAlt")}
          />
        </div>
      </section>

      <section className="grid gap-4 md:grid-cols-3">
        {highlights.map((item) => {
          const Icon = item.icon;

          return (
            <article
              key={item.titleKey}
              className="group rounded-[1.5rem] border border-white/10 bg-slate-900/95 p-5 shadow-xl shadow-black/20 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl border border-white/10 bg-gradient-to-br from-blue-500/20 to-purple-500/20">
                <Icon className="h-5 w-5 text-blue-100" />
              </div>
              <h3 className="text-xl font-semibold text-white">
                {t(item.titleKey)}
              </h3>
              <p className="mt-3 text-sm leading-6 text-slate-300">
                {t(item.descriptionKey)}
              </p>
            </article>
          );
        })}
      </section>

      <section className="rounded-[1.75rem] border border-white/10 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 p-6 shadow-2xl shadow-black/20 md:p-8">
        <div className="grid gap-4 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-center">
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.3em] text-blue-200/80">
              {t("company.closingTag")}
            </p>
            <h3 className="mt-3 text-2xl font-bold tracking-tight text-white md:text-3xl">
              {t("company.closingTitle")}
            </h3>
            <p className="mt-3 max-w-3xl text-base leading-7 text-slate-300">
              {t("company.closingBody")}
            </p>
          </div>

          {/* <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-5 py-3 text-sm font-semibold text-white">
            {t("company.closingAction")}
            <ArrowRight className="h-4 w-4" />
          </div> */}
        </div>
      </section>
    </div>
  );
};
